// Library Imports
import React from "react";
import ReactDOM from "react-dom/client";
import { HeroUIProvider } from "@heroui/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

// Local Imports
import "./main.css";
import App from "./App";
import { persistor, store } from "./redux/store";
import { queryClient } from "./lib/react-query/queryClient";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Remove Console for Production
if (import.meta.env.PROD) {
  console.log = () => {};
}

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <HeroUIProvider locale="en-US">
          <QueryClientProvider client={queryClient}>
            <App />
          </QueryClientProvider>
        </HeroUIProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);
